module.exports = __webpack_public_path__ + "img/zs1.721b74bc.jpg";